export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f553e5d9c0f6cba7ef5ee2d0cb62a80f8f7395f6a&name=fetchTypeahead!'